import { AxiosResponse } from 'axios';
import { IOrder } from 'shared/models/order';
import { apiDefault, apiV1, apiV2 } from './http';
import {
  ContractOrdersResponse,
  CreateOrderRequestData,
  OrdersSearchPayload,
  PatchOrderRequestData,
} from './interfaces/order';

export function load(token: string): Promise<AxiosResponse<IOrder>> {
  return apiV2.get<IOrder>(`orders/${token}`);
}

export function patch(
  payload: PatchOrderRequestData,
): Promise<AxiosResponse<IOrder>> {
  return apiV2.patch<IOrder>('orders', payload);
}

export function payWithCard(token: string): Promise<AxiosResponse> {
  return apiV2.get(`pagarme/one-off/${token}`);
}

export function cancel(orderId: number): Promise<AxiosResponse> {
  return apiV2.get(`orders/cancel/${orderId}`);
}

export function generateInvoice(token: string): Promise<AxiosResponse> {
  return apiDefault.get(`payment/order/generate-invoice/${token}`);
}

export function createOrder(
  payload: CreateOrderRequestData,
): Promise<AxiosResponse> {
  return apiV2.post('orders/create', payload);
}

export function getContractOrders(
  contractId: number,
  params: OrdersSearchPayload,
): Promise<AxiosResponse<ContractOrdersResponse>> {
  return apiV2.get<ContractOrdersResponse>('orders', {
    params: {
      ...params,
      contractId,
    },
  });
}

export function getCustomerOrders(
  customerId: number,
  params: OrdersSearchPayload,
): Promise<AxiosResponse<ContractOrdersResponse>> {
  return apiV2.get<ContractOrdersResponse>('orders', {
    params: {
      ...params,
      customerId,
    },
  });
}

export function getInvoiceUrl(
  orderId: number,
): Promise<AxiosResponse<{ url: string }>> {
  return apiV1.post<{ url: string }>('forecasts/invoice-url/internal', {
    orderId: String(orderId),
  });
}

export function reversalOrder(orderId: number): Promise<AxiosResponse> {
  return apiV2.post(`orders/reversal/${orderId}`);
}
